import {
  menu_item_base_styles_default
} from "./chunk.MKVWGLNN.js";
import {
  focusVisibleSelector
} from "./chunk.ZLFKGBZ6.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/menu-item/menu-item-checkbox.style.ts
var menu_item_checkbox_style_default = r` ${menu_item_base_styles_default} /** Checkbox Icon */ .menu-item .menu-item__check { font-size: 18px; display: flex; width: 18px; height: 18px; border: solid 1px var(--sl-color-gray-400); align-items: center; border-radius: 2px; top: calc(50% - 0.6em); visibility: visible; background-color: var(--sl-color-neutral-0); border-radius: var(--sl-border-radius-medium); margin-left: var(--sl-spacing-small); } .menu-item.menu-item--checked .menu-item__check { background: var(--sl-color-primary-600); border-color: var(--sl-color-primary-600); color: var(--sl-color-neutral-0); } .menu-item:not(.menu-item--checked) .menu-item__check fadv-icon::part(base) { display: none; } .checkbox__icon { display: inline-flex; width: 16px; height: 16px; } .menu-item:not(.menu-item--disabled):hover .menu-item__check, :host(${focusVisibleSelector}:not(.sl-focus-invisible):not([aria-disabled='true'])) .menu-item__check { border-color: var(--sl-color-primary-600); } `;

export {
  menu_item_checkbox_style_default
};
